/*
 * @Author: your name
 * @Date: 2020-11-25 20:22:41
 * @LastEditTime: 2022-10-27 15:22:20
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/modules/demo.js
 */
// Deep copy a copy of data
// 深度 copy 一份数据
const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initCheckinInfoState = {
  demo: 'demo',
  banner: '',
  logo: '',
  name: ''
}

const module_ = {
  state: cloneDeep(initCheckinInfoState),
  mutations: {
    // Initialize state
    // 初始化 state
    resetCheckinInfoState(state) {
      for (var i in initCheckinInfoState) {
        state[i] = initCheckinInfoState[i]
      }
    },

    saveCheckinInfo(state, venueCheckInfo) {
      Object.assign(state, venueCheckInfo)
    }
  },
  actions: {
  },
  getters: {
  }
}

export default module_